import http from 'hub-http/clients/apiClient';
const getAppObjectsFromNames = names => {
  return http.get('inbounddb-meta/v1/object-types/batch-get-by-names', {
    query: {
      name: names
    }
  });
};
export default getAppObjectsFromNames;